var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 10.125L25 11.8437L21.875 14.8125V25H26.25C27.2856 25 28.125 24.1606 28.125 23.125V10.125Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 10.125L4.13375 11.1937L8.125 14.8125V25H3.75C2.71437 25 1.875 24.1606 1.875 23.125V10.125Z",
    fill: "#1E88E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 7L15 12.1562L8.125 7L7.5 10.625L8.125 14.8125L15 19.9687L21.875 14.8125L22.5 10.625L21.875 7Z",
    fill: "#E53935"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 7.68625V10.125L8.125 14.8125V7L6.1725 5.53688C5.7075 5.18813 5.1425 5 4.56125 5C3.0775 5 1.875 6.2025 1.875 7.68625Z",
    fill: "#C62828"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 7.68625V10.125L21.875 14.8125V7L23.8275 5.53688C24.2925 5.18813 24.8575 5 25.4387 5C26.9225 5 28.125 6.2025 28.125 7.68625Z",
    fill: "#FBC02D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.25879791d001ab3f802380567215c303.svg";
export { ForwardRef as ReactComponent };